<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button autoHide="false"></ion-menu-button>
      <ion-back-button defaultHref="/call/dashboard" text="" icon="chevron-back"></ion-back-button>
    </ion-buttons>
    <ion-title>Trip History</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-refresher slot="fixed" (ionRefresh)="loadData($event, false)">
    <ion-refresher-content pullingIcon="caret-down" pullingText="Pull to refresh" refreshingSpinner="circles"
      refreshingText="Refreshing...">
    </ion-refresher-content>
  </ion-refresher>

  <ion-list *ngIf="listHistory.length" class="list-history">
    <ion-card class="ion-margin-top card-history" *ngFor="let item of listHistory">
      <ion-card-header>
        <div class="header">
          <h2 class="title">
            <div class="ico">
              <ion-img src="assets/images/map/car_normal.png" />
            </div>
            <p>
              {{ item.nomePassageiro }}
              <small>
                <ion-icon name="call"></ion-icon> {{ item.celular }}
              </small>
            </p>
          </h2>
        </div>
      </ion-card-header>

      <div class="card-body">
        <div class="data">
          <ion-item *ngIf="item.dataAgendamentoCorrida">
            <ion-icon name="alarm"></ion-icon>
            <ion-label>{{ item.dataAgendamentoCorrida | date: "MM/dd/yyyy h:mm a"}}</ion-label>
          </ion-item>
          <ion-item *ngIf="item.dataCorridaIniciada">
            <ion-icon name="calendar"></ion-icon>
            <ion-label>{{ item.dataCorridaIniciada | date: "MM/dd/yyyy h:mm a": 'GMT' }}</ion-label>
          </ion-item>
          <ion-item *ngIf="item.dataCorridaCancelada">
            <ion-icon name="close-circle-outline"></ion-icon>
            <ion-label>{{ item.dataCorridaCancelada | date: "MM/dd/yyyy h:mm a": 'GMT' }}</ion-label>
          </ion-item>
          <ion-item>
            <ion-icon name="pin" slot="start"></ion-icon>
            <ion-icon *ngIf="item.vendedor.porcentagem" name="flash" slot="start"></ion-icon>
            <ion-label>{{ item.enderecoOrigem }}</ion-label>
          </ion-item>
          <ion-item>
            <ion-icon name="navigate" slot="start"></ion-icon>
            <ion-label>{{ item.enderecoDestino }}</ion-label>
          </ion-item>
          <ion-item *ngIf="item.saldo">
            <ion-icon name="cash" slot="start"></ion-icon>
            <ion-label *ngIf="item.saldo && claim === userType.Driver">Trip price: {{ item.saldo.valorCorrida |
              currency
              }}
            </ion-label>
            <ion-label *ngIf="item.saldo && claim === userType.Caller && item.vendedor.id === user.id">Received: {{
              item.saldo.valorVendedor |
              currency }}</ion-label>
            <ion-label *ngIf="item.saldo && claim === userType.Caller && item.vendedor.id !== user.id">Received: {{
              item.saldo.valorVendedorIndicador | currency }}</ion-label>
            <ion-label *ngIf="item.saldo && claim === userType.Caller && item.vendedor.id !== user.id">Master
            </ion-label>
          </ion-item>
          <ion-item *ngIf="item.motivoCancelamento">
            <ion-icon name="chatbubbles" slot="start"></ion-icon>
            <ion-label>{{ item.motivoCancelamento }}</ion-label>
          </ion-item>
        </div>

        <div class="flags">
          <ion-img *ngIf="item.idiomas.includes(Languages.English)" src="assets/English.svg" class="ico" alt="" />
          <ion-img *ngIf="item.idiomas.includes(Languages.Portuguese)" src="assets/Portuguese.svg" class="ico"
            alt="" />
          <ion-img *ngIf="item.idiomas.includes(Languages.Spanish)" src="assets/Spanish.png" class="ico" alt="" />
          <ion-img *ngIf="item.idiomas.includes(Languages.Mandarin)" src="assets/Mandarin.png" class="ico" alt="" />
          <ion-img *ngIf="item.idiomas.includes(Languages.French)" src="assets/French.png" class="ico" alt="" />
          <ion-img *ngIf="item.idiomas.includes(Languages.Italian)" src="assets/Italian.png" class="ico" alt="" />
          <ion-img *ngIf="item.idiomas.includes(Languages.Japanese)" src="assets/Japanese.png" class="ico" alt="" />
          <ion-img *ngIf="item.idiomas.includes(Languages.Arabic)" src="assets/Arabic.png" class="ico" alt="" />
          <ion-img *ngIf="item.idiomas.includes(Languages.German)" src="assets/German.png" class="ico" alt="" />
          <ion-img *ngIf="item.idiomas.includes(Languages.Russian)" src="assets/Russian.png" class="ico" alt="" />
          <ion-img *ngIf="item.idiomas.includes(Languages.Vietnamese)" src="assets/Vietnamese.png" class="ico"
            alt="" />
        </div>
      </div>

      <div class="footer">
        <span class="status-badge" [ngClass]="'status-' + getCardColor(item)">
          <ion-icon name="flag"></ion-icon>
          {{ status[item.statusCorrida] | titlecase }}
        </span>
        <ion-badge color="primary" *ngIf="item.pagaPelaPlataforma">Platform Payment</ion-badge>
        <div class="footer-actions">
          <button *ngIf="claim === userType.Driver && item.statusCorrida !== status.ACCEPTED"
            class="btn-pill" (click)="newRaceDriver(item)">
            New Trip
          </button>
          <button *ngIf="item.statusCorrida === status.ACCEPTED" class="btn-pill btn-danger"
            (click)="cancelRace(item)">
            Cancel Trip
          </button>
          <button *ngIf="claim === userType.Caller && item.vendedor.id === user.id"
            class="btn-pill" (click)="newRaceCaller(item)">
            New Trip
          </button>
          <button *ngIf="
            item.tipoCorrida === TipoCorrida.IDAVOLTA &&
            item.etapaIdaVolta &&
            item.etapaIdaVolta === 1 &&
            !item.dataVolta && claim === userType.Driver
            && item.motorista.id === user.id" class="btn-pill" (click)="completeRoundTrip(item)">
            Complete Round Trip
          </button>
          <button *ngIf="
            item.statusCorrida !== status.FINISHED &&
            item.statusCorrida !== status.CANCELLED &&
            claim === userType.Driver &&
            item.motorista.id === user.id" class="btn-pill btn-go"
            (click)="item.statusCorrida === status.STARTED ? continueTrip(item) : completeRoundTrip(item)">
            Go
          </button>
          <button *ngIf="canShare(item)" class="btn-pill" (click)="shareTrip(item)">
            <ion-icon name="share-social-outline"></ion-icon>
            Share
          </button>
        </div>
      </div>
    </ion-card>
  </ion-list>

  <ion-list class="ion-padding ion-text-center" *ngIf="!listHistory.length" class="list-history">
    <ion-card class="ion-margin-top card-history">
      No results found.
    </ion-card>
  </ion-list>

  <div *ngIf="isOpenCanceling" class="container-comment" [ngClass]="{ open: isOpenCanceling }">
    <form [formGroup]="formCancelation">
      <h3>
        <ion-icon name="chatbox"></ion-icon>
        Please place the reason for the cancellation.
      </h3>

      <div class="container">
        <input formControlName="motivoCancelamento" type="text" class="input" placeholder="Enter reason" />
        <ion-button shape="round" size="small" (click)="postReason()" [disabled]="formCancelation.invalid">Send
        </ion-button>
      </div>
    </form>
  </div>
  <app-modal-component *ngIf="showModalFilter" (stateOpen)="showModalFilter = $event">
    <h3 style="font-weight: normal;">Here you can search for the history of all trips by name, period and status.</h3>
    <form [formGroup]="filterForm">
      <ion-item>
        <ion-label position="floating">Client name</ion-label>
        <ion-input type="text" formControlName="nomeCliente"></ion-input>
      </ion-item>
      <ion-item>
        <ion-label position="floating">Begin date</ion-label>
        <ion-input type="datetime-local" formControlName="dataInicio"></ion-input>
      </ion-item>
      <ion-item>
        <ion-label position="floating">End date</ion-label>
        <ion-input type="datetime-local" formControlName="dataFim"></ion-input>
      </ion-item>
      <ion-item>
        <ion-label position="floating">Trip status</ion-label>
        <ion-select formControlName="status">
          <ion-select-option *ngFor="let status of todosStatus" [value]="status.id">
            {{ status.name }}
          </ion-select-option>
        </ion-select>
      </ion-item>
    </form>
    <button class="ion-margin-top button-bigger grey animation-none" (click)="filterData(null, true)">Search</button>
  </app-modal-component>
  <ion-fab vertical="bottom" horizontal="end" slot="fixed" size="small">
    <ion-fab-button *ngIf="!isFiltered" color="primary" (click)="showFilter()">
      <ion-icon name="search"></ion-icon>
    </ion-fab-button>
    <ion-fab-button *ngIf="isFiltered" color="primary" (click)="loadData(null, false)">
      <ion-icon name="close"></ion-icon>
    </ion-fab-button>
  </ion-fab>
</ion-content>